module.exports = "16a4a0ec1dad61f02e4f2938ba48e04e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/spike-edge-R.png
// module id = 43
// module chunks = 0